import React from 'react';

export const SidebarSeparator = () => {
  return <div className={'w-0.5 h-3 min-h-[0.5rem] bg-neutral-30'}></div>;
};
